enum ProductState {
    Pending = "PENDING",
    Published = "PUBLISHED",
    Withdrawn = "WITHDRAWN"
}
export default ProductState